const enrollSuccessToAudit = {
  path: 'enrollSuccessToAudit',
  props: true,
  component: resolve => require(['../../../../../components/pages/student_user/homeClass/classEnroll/enrollSuccessToAudit'], resolve)
}
export default enrollSuccessToAudit



// WEBPACK FOOTER //
// ./src/router/pages/student_user/homeClass/classEnroll/enrollSuccessToAudit.js